<template>
  <Main/>
</template>

<script>
import './scss/main.scss';
import Main from './components/Main.vue'

export default {
  name: 'App',
  components: {
    Main
  }
}
</script>
